import React from "react";
import "./Header.css";

type HeaderProps = {
  heading: React.ReactNode;
  details?: React.ReactNode;
  className?: string;
};

const Header = ({ heading, details, className = "" }: HeaderProps) => {
  return (
    <div className={`header-container ${className}`}>
      <h1>{heading}</h1>
      {details ? <p>{details}</p> : null}
    </div>
  );
};

export default Header;
